import { render, staticRenderFns } from "./LeadBulkAction.vue?vue&type=template&id=3ddc00c6&"
import script from "./LeadBulkAction.vue?vue&type=script&lang=js&"
export * from "./LeadBulkAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports